import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RouteName, routeMap } from 'src/app/app.settings';

@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
})
export class SegmentComponent implements OnInit, OnDestroy {
  protected notifier = new Subject<void>();
  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private translate: TranslateService,
    private title: Title
  ) {}

  ngOnInit(): void {
    this.title.setTitle(this.translate.instant('modules.evcSegment.general.title'));
    this.analytics();

    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant('modules.evcSegment.general.title'));
    });
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  public goTo(location: string) {
    switch (location) {
      case 'b2c':
        const b2c =
          routeMap.find((el) => el.name === RouteName.simulator).basePath[this.translate.currentLang] +
          window.location.search;
        document.location.href = b2c;
        break;
      case 'sme':
        const sme =
          routeMap.find((el) => el.name === RouteName.smeQuote).basePath[this.translate.currentLang] +
          window.location.search;
        document.location.href = sme;
        break;
    }
  }

  private analytics() {
    // Initialize pageview event
    this.analyticsService.push({
      event: 'evcSegment-Pageview',
      page: {
        phase: 'sales',
        category: 'evc-simulator',
        branch: 'charging-station',
        simType: 'light',
        simulationConversion: 0,
        language: this.translate.currentLang,
      },
    });

    // Initialize step event
    this.analyticsService.push({
      event: 'evcSegment-Step',
      page: {
        step: `evcSegment.segmentType`,
      },
    });
  }
}
